import { getImageRoot, isLive } from '../../Utils/Utilities';
import { 
  Users, 
  FileQuestion, 
  CheckSquare, 
  UserCog, 
  Settings, 
  Link,
  Funnel,
  ListCheck,
  User
} from 'lucide-react';

const integrationsList = [
  { id: 1, name: "indiaMart", image: isLive() ? "/Web/assets/Images/Integrations/indiamart.png" : "/assets/Images/Integrations/indiamart.png", alt: "Indiamart" },
  { id: 2, name: "justDial", image: isLive() ? "/Web/assets/Images/Integrations/justdial.png" : "/assets/Images/Integrations/justdial.png", alt: "Justdial" },
  { id: 3, name: "tradeIndia", image: isLive() ? "/Web/assets/Images/Integrations/tradeindia.png" : "/assets/Images/Integrations/tradeindia.png", alt: "TradeIndia" },
  { id: 4, name: "meta", image: isLive() ? "/Web/assets/Images/Integrations/meta.png" : "/assets/Images/Integrations/meta.png", alt: "Meta" },
  { id: 8, name: "w3", image: isLive() ? "/Web/assets/Images/Integrations/w3.png" : "/assets/Images/Integrations/w3.png", alt: "W3" },
];

const inqTrainingData = {
    introduction: {
      title: "Welcome to SahiClub",
      description: "In order to maximize benefit from SahiClub, let us understand some <strong>key terms</strong>."
    },
    steps: [
      {
        title: "Contact",
        icon: <Users className="h-8 w-8 text-[var(--sahi-green)]" />,
        points: [
          "Your <strong>prospects</strong> or <strong>customers</strong> are your contacts.",
          "Multiple individuals can be associated with one Contact business.",
          "You can monitor <strong>multiple inquiries</strong> and tasks for a contact.",
          "You can increase <strong>repeat businesses</strong> by checking last interaction date with a contact."
        ]
      },
      {
        title: "Inquiry",
        icon: <Funnel className="h-8 w-8 text-[var(--sahi-green)]" />,
        points: [
          "An inquiry is by a specific <strong>contact</strong> for a specific <strong>offering</strong> (product / service).",
          "You can monitor which inquiries are <strong>closed</strong> or <strong>open</strong>.",
          "When the inquiry is completed, you can enter the received <strong>order value</strong>."
        ]
      },
      {
        title: "Tasks & Records",
        icon: <ListCheck className="h-8 w-8 text-[var(--sahi-green)]" />,
        points: [
          "<strong>Task</strong>: You can set a specific task (e.g. Meeting / Follow-up, Visit, etc.) for a contact.",
          "<strong>Record</strong>: You can maintain history of interactions / records with each contact by your team."
        ]
      },
      {
        title: "Users",
        icon: <User className="h-8 w-8 text-[var(--sahi-green)]" />,
        points: [
          "You can maintain <strong>multiple users</strong> and give them different <strong>access rights</strong>.",
          "You can compare their <strong>effort</strong> and <strong>performance</strong>."
        ]
      },
      {
        title: "Customization",
        icon: <Settings className="h-8 w-8 text-[var(--sahi-green)]" />,
        points: [
          "You can add fields that you want to see in contact.<br />Go to <strong>Settings</strong> > Click <strong>Extra Fields (Contact)</strong>.",
        ],
        mobileImage: getImageRoot("Training", "Extra_Field_Entry_mobile.png"),
        desktopImage: getImageRoot("Training", "Extra_Field_Conns_Entry_desktop.png")
      },
      {
        title: "Integrations",
        icon: <Link className="h-8 w-8 text-[var(--sahi-green)]" />,
        points: [
          "You can <strong>import leads</strong> from various sources and connect with Gmail to <strong>send emails</strong> directly from SahiClub."
        ],
        integrations: integrationsList
      }
    ]
  };

export const getTrainingData = (training) => {
  if(training == null || training == "") return [];
  let trainingSteps = [];

  switch (training){
    case "TRAINING1":
      trainingSteps = inqTrainingData;
      break;
  }

  return trainingSteps;
}